// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  advancedSlot: "SectionExplorer__advancedSlot",
  advancedToggle: "SectionExplorer__advancedToggle",
  backToForecast: "SectionExplorer__backToForecast",
  cutWhy: "SectionExplorer__cutWhy",
  deck: "SectionExplorer__deck",
  deckBtn: "SectionExplorer__deckBtn",
  deckCount: "SectionExplorer__deckCount",
  deckIcon: "SectionExplorer__deckIcon",
  deckLoop: "SectionExplorer__deckLoop",
  deckNav: "SectionExplorer__deckNav",
  deckStretch: "SectionExplorer__deckStretch",
  dial: "SectionExplorer__dial",
  "dial-loop": "SectionExplorer__dial-loop",
  dialHead: "SectionExplorer__dialHead",
  dialName: "SectionExplorer__dialName",
  dialNameWrap: "SectionExplorer__dialNameWrap",
  dialVal: "SectionExplorer__dialVal",
  dialValCopy: "SectionExplorer__dialValCopy",
  dialValTrack: "SectionExplorer__dialValTrack",
  heldRow: "SectionExplorer__heldRow",
  layout: "SectionExplorer__layout",
  leftCol: "SectionExplorer__leftCol",
  leftColSticky: "SectionExplorer__leftColSticky",
  lineActions: "SectionExplorer__lineActions",
  lineFoot: "SectionExplorer__lineFoot",
  lineOnly: "SectionExplorer__lineOnly",
  menu: "SectionExplorer__menu",
  menuItem: "SectionExplorer__menuItem",
  menuItemOn: "SectionExplorer__menuItemOn",
  ownPanel: "SectionExplorer__ownPanel",
  ownPanelHead: "SectionExplorer__ownPanelHead",
  paperNote: "SectionExplorer__paperNote",
  portrait: "SectionExplorer__portrait",
  rail: "SectionExplorer__rail",
  railClip: "SectionExplorer__railClip",
  railClipClosed: "SectionExplorer__railClipClosed",
  railInset: "SectionExplorer__railInset",
  railReveal: "SectionExplorer__railReveal",
  railToggle: "SectionExplorer__railToggle",
  retake: "SectionExplorer__retake",
  retakeIcon: "SectionExplorer__retakeIcon",
  scenario: "SectionExplorer__scenario",
  section: "SectionExplorer__section",
  selectCaret: "SectionExplorer__selectCaret",
  selectTrigger: "SectionExplorer__selectTrigger",
  selectWrap: "SectionExplorer__selectWrap",
  settingsLabel: "SectionExplorer__settingsLabel",
  spanFull: "SectionExplorer__spanFull",
  tab: "SectionExplorer__tab",
  tabOn: "SectionExplorer__tabOn",
  tabs: "SectionExplorer__tabs",
  trends: "SectionExplorer__trends",
  trendsBody: "SectionExplorer__trendsBody",
  trendsHead: "SectionExplorer__trendsHead",
  views: "SectionExplorer__views",
  whyInner: "SectionExplorer__whyInner",
  whySlot: "SectionExplorer__whySlot",
  whySlotOpen: "SectionExplorer__whySlotOpen",
  yours: "SectionExplorer__yours",
};
